import React, { useEffect, useState } from 'react';
import classes from "./styles/detailsSection.module.css";
import { formatDate4 } from '../../services/DateFormats';
import breifCaseIcon from "../../assets/svg/briefcase-outline.svg";
import locationIcon from "../../assets/svg/location-outline.svg";
import clockIcon from "../../assets/svg/time-outline.svg";
import DetailsPlaceHolder from './DetailsPlaceholder';
import { getInJoobleJobDetails } from '../../services/HirenzaJooble';
import { getAuJobG8JobDetails, getDeJobG8JobDetails, getFrJobG8JobDetails, getUsJobG8JobDetails } from '../../services/HirecrapJobG8';
import { getInBananaJobDetails, getUkBananaJobDetails, getUsBananaJobDetails } from '../../services/HirecrapBanana';

const DetailsSection = ({apiType, JobId}) => {
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const fetchJobDetails = async () => {
            try{
                if(apiType === "inj"){
                    const data = await getInJoobleJobDetails(JobId);
                    setData(data);
                }else if(apiType === "usg"){
                    const data = await getUsJobG8JobDetails(JobId);
                    setData(data);
                }else if(apiType === "frg"){
                    const data = await getFrJobG8JobDetails(JobId);
                    setData(data);
                }else if(apiType === "aug"){
                    const data = await getAuJobG8JobDetails(JobId);
                    setData(data);
                }else if(apiType === "deg"){
                    const data = await getDeJobG8JobDetails(JobId);
                    setData(data);
                }else if(apiType === "usb"){
                    const data = await getUsBananaJobDetails(JobId);
                    setData(data);
                }else if(apiType === "inb"){
                    const data = await getInBananaJobDetails(JobId);
                    setData(data);
                }else if(apiType === "ukb"){
                    const data = await getUkBananaJobDetails(JobId);
                    setData(data);
                }
            }catch(err){
                console.log("Error fetching Job details " + err);
            }finally{
                setLoading(false);
            }
        }
        fetchJobDetails();
    },[apiType, JobId])

  return (
    <>
        {loading && <DetailsPlaceHolder/>}

        {!loading && (
        <div className={classes.container}>
        <div className={classes.upperCon}>
            {/* <Link target='_blank' to={`/job-description/${apiType}${data?.id}?${data?.title.toLowerCase().replace(/\s+/g, '-')}`}> <img src={ArrowIcon} alt='arrow'  className={classes.arrow}/></Link> */}
            <div>
                <h2 className={classes.jobTitle}>{data?.title}</h2>
                <div className={classes.companyCon}>
                    <p><img src={breifCaseIcon} alt='company' className={classes.icon}/>{data?.company}</p>
                    <p><img src={locationIcon} alt='location' className={classes.icon}/>{data?.location}</p>
                    {data?.datePosted && <p><img src={clockIcon} alt='time' className={classes.icon}/>{ formatDate4(data?.datePosted)}</p>}
                </div>
            </div>
            <div>
                <button className={classes.applyBtn} onClick={() => { window.open(data?.uri, '_blank');}}>Apply</button>
            </div>
        </div>
        <div className={classes.desCon}>
        {data?.descriptionHTML ? <div dangerouslySetInnerHTML={{ __html: data?.descriptionHTML }} /> : data?.description ? <div style={{ whiteSpace: "pre-line" }}>{data?.description}</div> : <div dangerouslySetInnerHTML={{ __html: data?.summary }} />}
        </div>
      </div>)}
    </>
  )
}

export default DetailsSection
